import {
  SET_SITE_LOADING,
  SET_CATEGORIES,
  SET_CURRENT_CATEGORY,
  SET_MENU_STATUS,
  ADD_TO_BUCKET,
  REMOVE_FROM_BUCKET,
  SET_CATEGORY_PRODUCTS,
  SET_CURRENT_PAGE,
  SET_POPUP,
  SET_USER,
  SHOW_MESSAGE,
  SET_CATEGORY_MENU_STATUS,
  SET_OPTIONS
} from "../actions/types";

//console.log(hostname, " REACT_APP_BUILD -> ", process.env.REACT_APP_BUILD);

const initialState = {
  options: {},
  loading: { state: true, text: "" },
  menu: { open: false },
  categorymenu: { open: true },
  bucket: {},
  current: { page: 0 },
  popup: { type: false, show: false },
  message: { show: false, text: "YES BOSS" },
  pdfUrl: "https://eestipagar.ee/ep_catalog/pdfgen/",
  user: { loggedIn: false },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        user: action.user,
      };
    //, response, text
    case SHOW_MESSAGE:
      return {
        ...state,
        message: { ...state.message, show: action.show, text: action.text },
      };

    case SET_POPUP:
      return {
        ...state,
        popup: action.popup,
      };

    case ADD_TO_BUCKET:
      return {
        ...state,
        bucket: { ...state.bucket, [action.id]: action.item },
      };
    case REMOVE_FROM_BUCKET:
      let newBucket = state.bucket;
      delete newBucket[action.id];

      return {
        ...state,
        bucket: newBucket,
      };

    case SET_SITE_LOADING:
      return { ...state, loading: action.loadingArray };

    case SET_OPTIONS:
      return { ...state, options: action.response };

    case SET_CATEGORIES:
      return { ...state, categories: action.response };

    case SET_CURRENT_CATEGORY:
      return {
        ...state,
        current: { ...state.current, category: action.category },
      };

    case SET_CURRENT_PAGE:
      return {
        ...state,
        current: { ...state.current, page: action.page },
      };

    case SET_CATEGORY_PRODUCTS:
      return {
        ...state,
        products: { ...state.products, [action.id]: action.products },
      };

    case SET_MENU_STATUS:
      return {
        ...state,
        menu: { ...state.menu, open: action.state },
      };

    case SET_CATEGORY_MENU_STATUS:
      return {
        ...state,
        categorymenu: { ...state.categorymenu, open: action.state },
      };

    default:
      return state;
  }
}
